import type {
  CollectionState,
  FiltersMap,
  OptionalFiltersMap,
  SchemaSource,
} from '@wix/bex-core';
import { useCollection as useOpenCollection } from '@wix/bex-core/react';
import {
  schemaCollectionConfig,
  type SchemaCollectionOptions,
} from './schemaCollectionOptions';

/**
 * A bare collection driven by a schema source — data half only. For the fields
 * UI (columns, filters, field management) use a component hook from this entry
 * (`useTableCollection`, `useLayoutSwitchCollection`, …).
 */
export const useCollection = <T, F extends FiltersMap = OptionalFiltersMap>(
  source: SchemaSource<T>,
  options?: SchemaCollectionOptions<T, F>,
): CollectionState<T, F> =>
  useOpenCollection<T, F>(schemaCollectionConfig<T, F>(source, options));
